module.exports = __webpack_public_path__ + "img/1.b039a13b.jpg";